import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  // id: [
  //   {...makeRule('请输入正确的权限申请ID', 'integer', 'blur', false), min: 1},
  // ],
}

export let formRules = {
  name: [
    {...makeRule('请输入权限申请名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}



// WEBPACK FOOTER //
// ./src/views/permission-apply/permission-apply.rules.js